<template>
  <FormViewBase title="Email Recovery">
    <template #header>
      <v-btn
        exact
        outlined
        color="blue darken-2"
        :block="$mq | mq({ xs: true, md: false })"
        :to="{ name: MerchantLoginRoute }"
        class="mb-4"
        ><v-icon small left>mdi-arrow-left</v-icon>Back to Login</v-btn
      >
    </template>
    <template #default>
      <div class="text-h6"
        >If you've forgotten which email you use to login as the Owner of this
        shop, you may click the button below to send a message to the primary
        email on file.</div
      >
    </template>
    <template #errors>
      <v-alert v-if="!!error" type="warning" text>
        {{ error }}
      </v-alert>
    </template>
    <template #actions>
      <div class="text-center">
        <SendForgotEmailButton />
      </div>
    </template>
  </FormViewBase>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import { mapActions } from 'vuex'
import FormViewBase from '@/views/FormViewBase'
import RouteNames from '@/constants/RouteNames'
import SendForgotEmailButton from '@/components/SendForgotEmailButton'

import _get from 'lodash/get'
export default {
  name: 'ForgotEmailView',
  components: {
    FormViewBase,
    SendForgotEmailButton,
  },
  props: {
    token: {
      type: String,
      require: true,
    },
  },
  data() {
    return {
      email: '',
      newPass: '',
      error: null,
      success: true,
      MerchantLoginRoute: RouteNames.Merchant.LOGIN,
    }
  },
  computed: {
    ...mapFields('snackbars', ['showPasswordUpdatedSnackbar']),
  },
  methods: {
    ...mapActions('auth', ['resetPassword']),
    async updatePassword() {
      let { email, newPass: password, token } = this
      this.success = false
      this.$emit('sending')
      try {
        let { data: res } = await this.resetPassword({ email, password, token })
        this.success = true
        this.showPasswordUpdatedSnackbar = true
        let redirectPathName = RouteNames.Guest.HOME
        if (res.data.is_merchant) {
          redirectPathName = RouteNames.Merchant.LOGIN
        } else {
          redirectPathName = RouteNames.Customer.LOGIN
        }
        this.$router.push({ name: redirectPathName })
      } catch (error) {
        this.error = _get(
          error,
          'response.data.error.message',
          'Your password could not be reset.'
        )
      } finally {
        this.$emit('done')
      }
    }, // updatePassword
  },
}
</script>
